import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Typography, Box, Divider, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { LoadingButton } from '@mui/lab';
import { MapitPasswordTextField } from 'src/components/common';
import { useCancelSubscriptionMutation } from 'src/_api/planApi';
import moment from 'moment';

export default function CancelSubscriptionDialog({
    subscriptionInfo
}) {
    const { t } = useTranslation();
    const theme = useTheme();
    const [password, setPassword] = useState('');
    const [open, setOpen] = useState(false);

    const [
        cancelSubscription,
        {
            isLoading,
            isSuccess,
            error,
            reset
        }
    ] = useCancelSubscriptionMutation();

    const onClose = () => {
        setOpen(false);
        setPassword('');
    }

    const handleConfirm = async () => {
        try {
            await cancelSubscription({ password }).unwrap();
            setTimeout(() => {
                onClose();
            }, 2000);
        } catch (error) {
            console.log("Error cancelling subscription:", error);

        }
    };

    useEffect(() => {
        if (!open) {
            reset();
        }
    }, [open]);

    return (
        <>
            <Button
                variant="outlined"
                sx={{ textTransform: "none" }}
                onClick={() => setOpen(true)}
            >
                {t("Cancel Subscription")}
            </Button>
            <Dialog
                open={open}
                onClose={(e) => e.preventDefault()}
                fullWidth
            >
                <DialogTitle>
                    {t("Cancel Subscription")}
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <DialogContentText>
                        {t("confirmCancelSubscription", {
                            plan: theme.direction === "rtl" ? subscriptionInfo?.plan?.name_ar : subscriptionInfo?.plan?.name_en,
                            endDate: moment(subscriptionInfo?.endDate).format("DD MMM, YYYY")
                        })}
                    </DialogContentText>
                    <MapitPasswordTextField
                        label={t("Please enter your password to confirm cancel subscription.")}
                        name="password"
                        autoComplete="password"
                        value={password || ""}
                        required={true}
                        handleChange={(e) => setPassword(e.target.value)}
                        size="small"
                        margin="dense"
                    />
                </DialogContent>
                <Divider />
                <DialogActions>
                    {isSuccess && <Typography color="success.main">{t("Done successfully")}</Typography>}
                    {!!error && <Typography color="error">{error}</Typography>}
                    <Box mr="auto" />
                    <LoadingButton
                        onClick={onClose}
                        variant="contained"
                        disabled={isLoading}
                        sx={{ textTransform: "none" }}
                    >
                        {t("Close")}
                    </LoadingButton>
                    <LoadingButton
                        onClick={handleConfirm}
                        disabled={!password || isLoading || isSuccess}
                        loading={isLoading}
                        variant="contained"
                        sx={{ textTransform: "none" }}
                    >
                        {t("Confirm")}
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </>
    );
};